"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.CheckoutStepChangedEvent = exports.CheckoutStep = void 0;
const Name = exports.Name = 'checkout-step-changed';
const CheckoutStepChangedEvent = exports.CheckoutStepChangedEvent = Name;
let CheckoutStep = exports.CheckoutStep = /*#__PURE__*/function (CheckoutStep) {
  CheckoutStep[CheckoutStep["Basket"] = 1] = "Basket";
  CheckoutStep[CheckoutStep["Offers"] = 3] = "Offers";
  CheckoutStep[CheckoutStep["Delivery"] = 4] = "Delivery";
  CheckoutStep[CheckoutStep["Payment"] = 5] = "Payment";
  CheckoutStep[CheckoutStep["Review"] = 7] = "Review";
  return CheckoutStep;
}({});
//# sourceMappingURL=index.js.map